import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  coursesTypesFilterMenuAllCurses: {
    id: 'course-authoring.studio-home.courses.tab.types-filter-menu.all-courses',
    defaultMessage: 'All courses',
  },
  coursesTypesFilterMenuActiveCurses: {
    id: 'course-authoring.studio-home.courses.tab.types-filter-menu.active-courses',
    defaultMessage: 'Active',
  },
  coursesTypesFilterMenuArchivedCurses: {
    id: 'course-authoring.studio-home.courses.tab.types-filter-menu.archived-courses',
    defaultMessage: 'Archived',
  },
});

export default messages;
